var map = {
	"./display-theme1": 52473,
	"./display-theme1.tsx": 52473,
	"./display-theme2": 2330,
	"./display-theme2.tsx": 2330,
	"./display-theme3": 80191,
	"./display-theme3.tsx": 80191,
	"./display-theme4": 93176,
	"./display-theme4.tsx": 93176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27693;